import React, { useState, useEffect } from "react";
import {
  Grid,
  Button,
  TextareaAutosize,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  List,
  ListItem,
  Select,
  Card,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import PageHeader from "../../../Components/PageHeader";
import LeftControl from "../../../Components/LeftControl";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router";
import { environment } from "../../../environments/environment";

// import { withRouter } from 'react-router-dom';
// import MobileScreen from './Mobile/Enter-RailRoad-Add';
// import {isMobile} from 'react-device-detect';

/** Local deoendencies & Libraries */
import Services from "../../../Services";
import Snackbar from "../../../Components/Snackbar";
import { helpers } from "../../../helpers";
import ListItemResult from "../../../Components/LayoutComponents/ListItemResult";
import HireITformFields from "../../../Components/newHireITFormFields/HireITformFields";
import {
  showText,
  showTextEmpty,
  ValidateDate,
  ValidateISODate,
} from "../../../helpers/textValidation";
import GoBack from "../../../Components/GoBackButton/GoBack";
import { message } from "antd";
import PageLayout from "../../../Components/LayoutComponents/PageLayout";
const { hr, IT } = Services;
const { showSnackBar } = helpers;
var moment = require("moment-timezone");

const { apiPath } = environment;

const OnBoarding = () => {
  let history = useHistory();
  const location = useLocation();

  const [activeDirectory, setActiveDirectory] = useState({
    orderDate: "",
    completeDate: null,
    isChanged: false,
    dnUid: null,
    isChanged: false,
  });

  const [email, setEmail] = useState({
    orderDate: "",
    completeDate: null,
    isChanged: false,
  });

  const [computer, setComputer] = useState({
    orderDate: "",
    completeDate: null,
    isChanged: false,
  });

  const [cell, setCell] = useState({
    orderDate: "",
    completeDate: null,
    isChanged: false,
  });

  const [vehicle, setVehicle] = useState({
    orderDate: "",
    completeDate: null,
    isChanged: false,
  });

  const [fuelCard, setFuelCard] = useState({
    orderDate: "",
    completeDate: null,
    isChanged: false,
  });

  const [applicantData, setApplicantData] = useState({
    Employee: {
      firstName: "",
      middlename: "",
      lastName: "",
      id: "",
      SubDepartment: {
        name: "",
      },
      joiningDate: "",
    },
  });

  useEffect(() => {
    //  
  }, [activeDirectory]);


  useEffect(() => {
    let data = location?.state;

    setApplicantData(data);
    setActiveDirectory({
      ...activeDirectory,
      completeDate: data?.AD_cd,
      dnUid:data?.Applicant?.uid  || data?.Employee?.uid ,  
      isChanged: data?.AD_cd ? true : false,
    });
    setComputer({
      ...computer,
      completeDate: data?.computer_cd,
      isChanged: data?.computer_cd ? true : false,
    });
    setVehicle({
      ...vehicle,
      completeDate: data?.company_vehicle_cd,
      isChanged: data?.company_vehicle_cd ? true : false,
    });
    setCell({
      ...cell,
      completeDate: data?.cell_phone_cd,
      isChanged: data?.cell_phone_cd ? true : false,
    });
    setFuelCard({
      ...fuelCard,
      completeDate: data?.fuel_card_cd,
      isChanged: data?.fuel_card_cd ? true : false,
    });
  }, []);


  async function onFormSubmit(event) {
    event.preventDefault();
    let data = {};
    if (activeDirectory.completeDate && !activeDirectory.isChanged) {
      data.AD_cd = activeDirectory.completeDate;
      data.dnUid = activeDirectory.dnUid;
    }

    if (computer.completeDate && !computer.isChanged)
      data.computer_cd = computer.completeDate;

    if (cell.completeDate && !cell.isChanged)
      data.cell_phone_cd = cell.completeDate;

    if (vehicle.completeDate && !vehicle.isChanged)
      data.company_vehicle_cd = vehicle.completeDate;

    if (fuelCard.completeDate && !fuelCard.isChanged)
      data.fuel_card_cd = fuelCard.completeDate;

    data.ITComment = document.getElementById("comment").value;

    const nullCheck = Object.values(data).reduce(
      (total, accumulator) => total || !accumulator,
      false
    );

    if (!nullCheck) {
      try {
        let res = await IT.update_it_request({ id: applicantData.id, data });
        if ((res.httpStatus = 200)) {
          setTimeout(() => {
            history.push("/new-hire-queue-it");
          }, 1500);
          return message.success('Form Successfully Submitted');

        }
      } catch (error) {
        return message.error(error.message);
      }
    } else {
      return message.error("Fill Form Correctly");
    }
  }




  const newHireITData = [
    {
      head: "New Hire Name",
      text: ` ${showText(applicantData?.Employee?.firstName || applicantData?.Applicant?.firstName)} ${showTextEmpty(
        applicantData?.Employee?.lastName || applicantData?.Applicant?.lastName
      )}`,
      span: false,
      visibility: true,
      showButton: false,
    },
    {
      head: "New Hire ID",
      text: showText(applicantData?.Employee?.id || applicantData?.Applicant?.id),
      span: false,
      visibility: true,
      showButton: false,
    },
    {
      head: "Department",
      text: showText(applicantData?.Employee?.SubDepartment?.name || applicantData?.Applicant?.SubDepartment?.name),
      span: false,
      visibility: true,
      showButton: false,
    },
    {
      head: "Location",
      text: showText(applicantData?.Employee?.TGSLocation?.name || applicantData?.Applicant?.TGSLocation?.name),
      // || applicantData?.Applicant?.TGSLocation?.address)
      span: false,
      visibility: true,
      showButton: false,
    },
    {
      head: "Supervisor",
  
      text: showText(
        (applicantData?.Employee &&
          applicantData.Employee.SEmployee &&
          applicantData.Employee.SEmployee.firstName + " " +
          applicantData.Employee.SEmployee.lastName) ||
        (applicantData?.Applicant &&
          applicantData.Applicant.SEmployee &&
          applicantData.Applicant.SEmployee.firstName + " " +
          applicantData.Applicant.SEmployee.lastName) ||
        "No Data Available"
      ),

      span: false,
      visibility: true,
      showButton: false,
    },
    {
      head: "Start Date",
      text: ValidateDate(applicantData?.Employee?.joiningDate || applicantData?.Applicant?.joiningDate),
      span: false,
      visibility: true,
      showButton: false,
    },

    {
      head: "HR Comment",
      text: showText(applicantData?.HRComment),
      span: false,
      visibility: true,
      showButton: false,
    },
    {
      head: "Previous IT Comment",
      text: showText(applicantData?.ITComment),
      span: false,
      visibility: true,
      showButton: false,
    },
  ];


  const HireITData = [
    {
      visibility: applicantData?.AD,
      name: "Active Directory",
      orderDateData: {
        id: "AD_od",
        isDisabled: true,
        value: ValidateDate(applicantData.AD_od),
        onChange: (e) => {
          setActiveDirectory({
            ...activeDirectory,
            orderDate: e.target.value,
          });
        },
      },
      dateCompletedData: {
        id: "AD_cd",
        isDisabled: applicantData?.AD_cd ? true : false,
        value:
          activeDirectory?.completeDate &&
          ValidateISODate(activeDirectory.completeDate),
        type: "date",
        inputPropDate: applicantData?.AD_od,
        onChange: (e) => {
          setActiveDirectory({
            ...activeDirectory,
            completeDate: e.target.value,
          });
        },
      },
      uidData: {
        showUidField: activeDirectory.completeDate,
        id: "AD_uid",
        isDisabled: activeDirectory.isChanged,
        isRequired: !activeDirectory.isChanged,
        value: activeDirectory.isChanged ? applicantData?.Employee?.uid || applicantData?.Applicant?.uid : activeDirectory.dnUid,  // Conditionally set the value
        placeholder: "UID",
        onChange: (e) => {
          // Only update if it's not disabled
          if (!activeDirectory.isChanged) {
            setActiveDirectory({
              ...activeDirectory,
              dnUid: e.target.value,  // Update the value in state only if not disabled
            });
          }
        },
      },      
    },
    {
      visibility: applicantData?.computer,
      name: "Computer",
      orderDateData: {
        id: "computer_od",
        isDisabled: true,
        value: ValidateDate(applicantData.computer_od),
        defaultValue: "YY-MM-DD",
      },
      dateCompletedData: {
        id: "computer_cd",
        isDisabled: computer?.completeDate ? true : false,
        value: computer?.completeDate && ValidateISODate(computer.completeDate),
        type: "date",
        inputPropDate: applicantData?.computer_od,
        format: "MM/DD/YYYY",
        onChange: (e) => {
          setComputer({
            ...computer,
            completeDate: e.target.value,
          });
        },
      },
      uidData: {
        showUidField: false,
      },
    },
    {
      visibility: applicantData?.cell_phone,
      name: "Cell Phone",
      orderDateData: {
        id: "cell_phone_od",
        isDisabled: true,
        value: ValidateDate(applicantData.cell_phone_od),
        defaultValue: "YY-MM-DD",
      },
      dateCompletedData: {
        id: "cell_phone_cd",
        isDisabled: applicantData.cell_phone_cd ? true : false,
        value: cell?.completeDate && ValidateISODate(cell.completeDate),
        type: "date",
        inputPropDate: applicantData?.cell_phone_od,
        onChange: (e) => {
          setCell({
            ...cell,
            completeDate: e.target.value,
          });
        },
      },
      uidData: {
        showUidField: false,
      },
    },
    {
      visibility: applicantData?.company_vehicle,
      name: "Company Vehicle",
      orderDateData: {
        id: "compamy_vehicle_od",
        isDisabled: true,
        value: ValidateDate(applicantData.company_vehicle_od),
      },
      dateCompletedData: {
        id: "company_vehicle_cd",
        isDisabled: applicantData.company_vehicle_cd ? true : false,
        value: vehicle?.completeDate && ValidateISODate(vehicle.completeDate),
        type: "date",
        inputPropDate: applicantData?.company_vehicle_od,
        onChange: (e) => {
          setVehicle({
            ...vehicle,
            completeDate: e.target.value,
          });
        },
      },
      uidData: {
        showUidField: false,
      },
    },
    {
      visibility: applicantData?.fuel_card,
      name: "Fuel Card",
      orderDateData: {
        id: "fuel_card_od",
        isDisabled: true,
        value: ValidateDate(applicantData.fuel_card_od),
        inputPropDate: applicantData?.fuel_card_od,
      },
      dateCompletedData: {
        id: "fuel_card_cd",
        isDisabled: applicantData.fuel_card_cd ? true : false,
        value: fuelCard?.completeDate && ValidateISODate(fuelCard.completeDate),
        type: "date",
        inputPropDate: applicantData?.fuel_card_od,
        onChange: (e) => {
          setFuelCard({
            ...fuelCard,
            completeDate: e.target.value,
          });
        },
      },
      uidData: {
        showUidField: false,
      },
    },
  ];
  return (
    <PageLayout className="Liq-Container HRPortal">
      <Grid className="PagesFrame">
        <PageHeader />
        <Grid id="PageTitle">IT New Hire Onboarding</Grid>
        {/* Page Start */}
        <GoBack path="/new-hire-queue-it" />
        <Grid className="mt20" xs={6}>
          <ListItemResult data={newHireITData} />
        </Grid>

        <Grid
          style={{ margin: "0" }}
          xs={12}
          className="ContentPage BlueHeadTable FormTableArea"
        >
          <Grid xs={12} md={8} lg={6}>
            <form onSubmit={onFormSubmit}>
              <Grid xs={12} container className="LRM40">
                <Grid xs={4} className="mt30 pr20">
                  <Grid xs={12}>
                    <Grid xs={12} className="mbold"></Grid>
                  </Grid>
                </Grid>
                <Grid xs={8} container className="mt30 pl20">
                  <Grid xs={6} className="pr20">
                    <Grid xs={12} className="mbold mb14">
                      Order Date
                    </Grid>
                  </Grid>
                  <Grid xs={6} className="pl20">
                    <Grid xs={12} className="mbold mb14">
                      Date Completed
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <HireITformFields data={HireITData} />

              <Grid xs={12} container className="LRM40 mt20">
                <Grid
                  xs={4}
                  style={{ alignSelf: "center" }}
                  className="pr20 mt4"
                >
                  <Grid xs={12}>
                    <Grid xs={12} className="mbold">
                      Notes
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid xs={12} container className="LRM40">
                <Grid
                  xs={12}
                  style={{ alignSelf: "center" }}
                  className="pr20 mt4"
                >
                  <Grid xs={12}>
                    <Grid xs={12} className="mbold">
                      <TextareaAutosize
                        style={{ width: "100%" }}
                        required
                        id="comment"
                        className="w100p"
                        rowsMin={6}
                        placeholder="Comment here"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                xs={12}
                container
                justify="space-between"
                className="mt50"
              >
                <Link to="/new-hire-queue-it" className="LinkButtonBack">
                  Back
                </Link>
                <Button className="LinkButton" type="submit">
                  Save & Continue
                </Button>
              </Grid>
            </form>
          </Grid>
          <Snackbar></Snackbar>
        </Grid>
        {/* Page Start End */}
      </Grid>
    </PageLayout>
  );
};

export default OnBoarding;
